import {COLOR_STEPS, PROFILE_PROGRESS_THRESHOLDS} from '../constants';
import {RGB} from '../types';

const interpolate = (start: number, end: number, ratio: number) =>
	Math.round(start + (end - start) * ratio);

const interpolateColor = (from: RGB, to: RGB, ratio: number): string => {
	const r = interpolate(from.r, to.r, ratio);
	const g = interpolate(from.g, to.g, ratio);
	const b = interpolate(from.b, to.b, ratio);

	return `rgb(${r}, ${g}, ${b})`;
};

export const getProgressColor = (value: number): string => {
	const clampedValue = Math.max(0, Math.min(PROFILE_PROGRESS_THRESHOLDS.MAX, value));

	const step =
		COLOR_STEPS.find(({start, end}) => clampedValue >= start && clampedValue <= end) ??
		COLOR_STEPS[COLOR_STEPS.length - 1];

	const range = step.end - step.start;
	const ratio = range === 0 ? 0 : (clampedValue - step.start) / range;

	return interpolateColor(step.from, step.to, ratio);
};
